import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const ButtonWrapper = styled.div`
  display: grid;
  gap: 5px;
  grid-template-columns: auto;
`;

export const SpaDetails = styled.div`
  color: ${({ theme }) => theme.defaultColors.darkGrey};
`;

export const SpaDetailsClasses = styled(SpaDetails)`
  margin-top: 10px;
  display: flex;
  align-items: center;
  grid-column: 1 / span 2;
  span {
    margin: 0 5px;
  }
  ${media.md`
    gap: 5px;
    margin-left: -5px;
    margin-left: 0;
    grid-column: 1 / span 1;
  `}
`;

export const SpaClassesDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;
  white-space: nowrap;
`;

export const SpaItemName = styled.div`
  color: #444;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
`;

export const SpaDetailsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media screen and (max-width: 850px) {
    margin-bottom: 0;
  }
`;

export const SpaDetailsHeadSection = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 1rem;
`;

export const GuestCounterWrapper = styled.div`
  grid-row: 1 / span 2;
  grid-column: 2;
  align-self: flex-start;
  justify-self: flex-end;

  div[class^='Popper'] {
    padding: 0;
  }

  div[class*='PopperOptionLabel'] {
    margin-right: 10px;
  }
`;

export const ShowMoreLess = styled.span`
  display: block;
  margin: ${({ theme }) => theme.spaces['SPACE_2']} 0;
  white-space: pre-wrap;
  cursor: pointer;
  width: fit-content;
  color: #c89384;
  font-weight: 400;
  text-decoration: underline;
`;
